import { get } from 'lodash'

const pickValuesAtPaths = <T extends Record<string, unknown>>(source: T, keys: (keyof T)[]) =>
  keys.map((key) => get(source, key))

export default pickValuesAtPaths
